import { Component, Input, OnInit } from '@angular/core';
import { InputComponent, MakeProvider } from '../input-component';

@Component({
  selector: 'app-toggle-input',
  templateUrl: './toggle-input.component.html',
  styleUrls: ['./toggle-input.component.scss', '../form-inputs-style.scss'],
  providers: [MakeProvider(ToggleInputComponent)]
})
export class ToggleInputComponent extends InputComponent implements OnInit {

  @Input() maxWidth = 'none';
  @Input() compact = false;

  constructor() { super(); }

  ngOnInit() { }

  override checkValidity() {
    super.checkValidity();
  }
}
